import {
  CreatorPermission,
  type CreatorPermissionViewMember,
  DetailedPermission,
} from '@api'

import type { Creator, CreatorProxyStatus, ProxyStatus } from './types'
import { CreatorPermissionState, CreatorStatus } from './types'
import type { CreatorAccessEditFormValues } from './views/edit-access/form'

export function replaceCreatorPath(
  input: string,
  replacementId: number,
): string {
  return input.replace(/^\/c\/\d+\//, `/c/${replacementId}/`)
}

export const isActiveCreator = (creator: Creator) => {
  return (
    creator.status.length === 0 ||
    [CreatorStatus.Upgradeable, CreatorStatus.NotUpgradeable].includes(
      creator.status[0],
    )
  )
}

export const isValidCreator = (creator: Creator) => {
  return creator.id && creator.name && creator.onlyfansId && creator.status
}

const isValidPermissionKey = (
  permission: string,
): permission is CreatorPermission => {
  return Object.values(CreatorPermission).some((p) => p === permission)
}

const createPermissionsMap = (
  permissions: CreatorPermission[],
  rolesPermissions: CreatorPermission[],
  availablePermissions: DetailedPermission[],
) => {
  return availablePermissions.reduce(
    (acc, { value }) => {
      if (value && isValidPermissionKey(value)) {
        acc[value] = permissions.includes(value)
          ? CreatorPermissionState.On
          : rolesPermissions.includes(value)
            ? CreatorPermissionState.Inherited
            : CreatorPermissionState.Off
      }

      return acc
    },
    {} as Record<CreatorPermission, CreatorPermissionState>,
  )
}

export const getCreatorAccessEditFormInitialValue = (
  members: CreatorPermissionViewMember[],
  availablePermissions: DetailedPermission[],
): CreatorAccessEditFormValues['permissions'] => {
  return members.map(({ member, permissions, rolesPermissions }) => ({
    memberId: member!.id,
    memberName: member!.name,
    ...createPermissionsMap(
      permissions,
      rolesPermissions || [],
      availablePermissions,
    ),
  }))
}

export function getCreatorProxyStatusByCreatorId(
  creatorStates: CreatorProxyStatus[],
  creatorId: number,
): ProxyStatus {
  return (
    creatorStates.find((state) => state.id === creatorId)?.status ||
    'NotLoggedIn'
  )
}
